const initialState = {
  meta: {
    isDistribution: '',
    isPortfolio: '',
    isPortfolioDetail: '',
    isReminders: '',
    isSummary: '',
    isMovement: '',
    isAccount: ''
  },
  data: {
    summary: {},
    movement: [],
    distribution: {
      detail: [],
      charts: []
    },
    portfolio: {
      items: [],
      outstandingOrders: [],
      detail: {},
      goldSummary: {},
      goldItems: [],
      goldTrx: []
    },
    transaction: {
      gold: []
    },
    reminders: [],
    detail: {},
    account: {
      ifua: '',
      sid: ''
    },
    page: {
      current_page: 1,
      next_page: 1,
      previous_page: 1,
      total_data: 0,
      total_pages: 0
    }
  }
}

export default (state = initialState, action) => {
  const { type, payload, others = {} } = action
  switch (type) {
    case 'SET_PORTFOLIO_META':
      return {
        ...state,
        meta: {
          ...state.meta,
          [payload.field]: payload.payload,
          ...others
        }
      }
    case 'SET_PORTFOLIO_DATA':
      return {
        ...state,
        data: {
          ...state.data,
          [payload.field]: payload.payload,
          ...others
        }
      }
    case 'SET_PORTFOLIO_DATA_DISTRIBUTION':
      return {
        ...state,
        data: {
          ...state.data,
          distribution: {
            ...state.data.distribution,
            [payload.field]: payload.payload,
            ...others
          }
        }
      }
    default:
      return state
  }
}
